module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a213a0b297d31a50e37d52eb96831d40.png";